import { List, fromJS } from 'immutable';

const KEY = 'multiples';

export function request(state) {
    return state.setIn([ KEY, 'status' ], 'IN_PROGRESS');
}

export function error(state, { errors }) {
    return state.setIn([ KEY, 'errors' ], errors)
        .setIn([ KEY, 'status' ], 'ERROR');
}

export function finish(state, { lines } ) {
    return state.setIn([ KEY, 'status' ], 'FINISHED')
        .setIn([ KEY, 'items' ], fromJS(lines) || List() );
}
